import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditTable from '../../tables/EditTable';
import Tabs from '../../common/Tabs';
import Pagination from '../../common/Pagination';
import Card from '../../common/Card';
import Label from '../../common/Label';
import SelectSearch from '../../common/SelectSearch';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeRequestControllerService, MenuControllerService } from '../../../services';
import { fetchCompetitorChainsByStoreCode, fetchCompetitorStoresByStoreCode, fetchStores, setLoader } from '../../../redux/actions/api';
import ReactCalender from '../../common/Datepicker';
import Button from '../../common/Button';
import { createCompetitorChainOptions, createCompetitorStoreOptions, createStoreOptions } from '../../../utils/helpers/option';
import apiErrorHandler from '../../../api/apiErrorHandler';
import { getDeviationRates } from '../../../utils/helpers/formula';
import { useLocation } from 'react-router-dom';
import { clearErrors } from '../../../redux/actions/error';
import Modal from '../../common/Modal';
import Popup from '../../common/Popup';
import { getNbpbkbnTable } from '../../tables/table';
import ViewTable from '../../tables/ViewTable';
import { setToastsError } from '../../../redux/actions/common';
import { addConfirmedData, addSelectedData, checkPble, updateSelectedData } from '../../../utils/helpers/common';

const ChangeRequestBase = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const {
        table,
        confirmStatus,
        apiResponse,
        setApiResponse,
        reload,
        confirmRequestId,
        editedId = '',
        clearEditedId,
        selectedData,
        setSelectedData,
        btn,
        isShowForm,
        setIsShowForm,
        isNearby,
    } = props;

    // 申請画面
    const isRequestingPage = confirmStatus === 'REQUESTING';
    // 承認画面
    const isConfirmPage = confirmStatus === 'NOT_CONFIRM';
    // 差戻画面
    const isRemandPage = confirmStatus === 'REMAND';

    const constants = useSelector((state) => state.constants);
    const { stores, competitorStores, competitorChains } = constants;
    const storage = useSelector((state) => state.storage);
    const { isCompetitor, changeRequestType } = storage;
    const sort = useSelector((state) => state.sort);

    const [state, setState] = useState({
        page: 1,
        limit: isConfirmPage ? 300 : 20,

        // 申請画面
        selectedCompetitorChainCode: '',
        selectedCompetitorStoreCode: '',
        selectedStoreCode: '',

        // 差戻画面
        requestedDate: null,

        isShowModal: false,
        isShowedModal: false,

        isShowedNbpbkbnModal: false,
        isShowNbpbkbnModal: false,
        nbpbkbnData: null,

        nearbyCount: 0,

        paginate: new Date(),
    });

    const {
        page,
        limit,
        selectedCompetitorChainCode,
        selectedCompetitorStoreCode,
        selectedStoreCode,

        requestedDate,

        isShowModal,
        isShowedModal,

        isShowedNbpbkbnModal,
        isShowNbpbkbnModal,
        nbpbkbnData,

        nearbyCount,

        paginate,
    } = state;

    useEffect(() => {
        getChangeRequests(page);
    }, [changeRequestType, sort]);

    useEffect(() => {
        dispatch(clearErrors());
        // 初回の処理ではしない
        if (isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        setSelectedData([]);
        getChangeRequests(1);
    }, [dispatch, location, reload, isShowForm, isFirstLoad]);

    useEffect(() => {
        updateSelectedData(changeRequestType, [editedId], setSelectedData);
    }, [editedId]);

    const getChangeRequests = (pageNumber) => {
        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('page', pageNumber);
        handleChangeState('isShowModal', false);

        if (selectedCompetitorChainCode ? !selectedCompetitorStoreCode : false) {
            dispatch(setLoader(false));
            dispatch(setToastsError('競合店舗名を選択してください。'));
            return;
        }

        if (!isRemandPage) {
            MenuControllerService.getCompetitorNearbyStoresBadge(confirmStatus)
                .then((response) => {
                    setState((prevState) => ({
                        ...prevState,
                        nearbyCount: response,
                    }));
                })
                .catch((error) => {
                    apiErrorHandler(dispatch, error);
                });
        }

        const request = isNearby
            ? ChangeRequestControllerService.getChangeRequestsNearbyStores(
                  confirmStatus,
                  selectedCompetitorChainCode ? selectedCompetitorChainCode : null,
                  selectedCompetitorStoreCode ? selectedCompetitorStoreCode : null,
                  selectedStoreCode ? selectedStoreCode : null,
                  confirmRequestId ? confirmRequestId : null,
                  pageNumber,
                  limit,
                  table.heads.find((head) => head.field === sort.sortField)?.field,
                  sort.sortType,
              )
            : ChangeRequestControllerService.getChangeRequests(
                  changeRequestType,
                  confirmStatus,
                  requestedDate ? requestedDate : null,
                  pageNumber,
                  limit,
                  table.heads.find((head) => head.field === sort.sortField)?.field,
                  sort.sortType,
              );
        request
            .then(async (response) => {
                response.data = response.data.map((data) => {
                    if (!isShowModal && data.linkedItemFlag && !isShowedModal) {
                        setState((prevState) => ({
                            ...prevState,
                            isShowModal: true,
                            isShowedModal: true,
                        }));
                    }

                    return {
                        ...data,
                        itemName: data.itemName + (data.linkedItemFlag ? '（荷姿連動）' : ''), // 連動商品は商品名の後ろに「（荷姿連動）」を表示
                        selected: (selectedData.some((dataItem) => dataItem.id === data.id) || editedId === data.id) ?? false, // 申請画面選択用
                        confirmed:
                            (selectedData.some((dataItem) => dataItem.id === data.id && dataItem.confirmed) && isConfirmPage) ?? false, // 承認画面選択用（承認）
                        remand: (selectedData.some((dataItem) => dataItem.id === data.id && dataItem.remand) && isConfirmPage) ?? false, // 承認画面選択用（差戻）
                    };
                });
                clearEditedId && clearEditedId();
                const nbpbkbnItems = response.data.filter((item) => checkPble(item.pbleFlag, item.exception));

                if (isCompetitor && nbpbkbnItems.length > 0 && !isShowedNbpbkbnModal) {
                    setState((prevState) => ({
                        ...prevState,
                        nbpbkbnData: nbpbkbnItems,
                        isShowNbpbkbnModal: true,
                        isShowedNbpbkbnModal: true,
                    }));
                }
                setApiResponse(response);
                await getPromiseResult(response.data);
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error);
            })
            .finally(() => {
                dispatch(fetchStores());
                dispatch(fetchCompetitorChainsByStoreCode());
                dispatch(fetchCompetitorStoresByStoreCode());
                handleChangeState('paginate', new Date());
                dispatch(setLoader(false));
            });
    };

    const [discounts, setDiscounts] = useState([]);
    const getPromiseResult = async (responseData) => {
        const data = await discountCheck(responseData);
        setDiscounts(data);
    };

    const discountCheck = async (items) => {
        if (!items) {
            return [];
        }
        try {
            const responses = await getDeviationRates(dispatch, items);

            const results = await Promise.all(
                responses.map(async (item) => {
                    const deviationRate = item.deviationRate;

                    if (deviationRate >= 30) {
                        return '30%';
                    }

                    // 表示色の判定優先度は10％乖離より連動商品が優先
                    if (item.linkedItemFlag) {
                        return 'linkedItem';
                    }

                    if (deviationRate >= 10) {
                        return '10%';
                    }
                    return '';
                }),
            );

            return results;
        } catch (error) {
            return [];
        }
    };

    const renderTable = () => {
        return (
            <EditTable
                confirmStatus={confirmStatus}
                heads={table.heads}
                body={table.body}
                dataTable={apiResponse?.data}
                setDataTable={setDataTable}
                discounts={discounts}
                dataText={'該当商品が見つかりません。'}
                pagination={paginate}
                setSelectedData={handleSetSelectedData}
            />
        );
    };

    const handleSetSelectedData = () => {
        if (isConfirmPage) {
            addConfirmedData(apiResponse, setSelectedData);
        } else {
            addSelectedData(apiResponse, setSelectedData);
        }
    };

    const setDataTable = (data) => {
        setApiResponse({
            ...apiResponse,
            data,
        });
    };

    const handleShowForm = (value) => {
        setState((prevState) => ({
            ...prevState,
            apiResponse: null,
            page: 1,
        }));
        setIsShowForm(value === 'mailConfirmTab');
    };

    const handlePageClick = (event) => {
        const pageNumber = event.selected + 1;
        getChangeRequests(pageNumber);
    };

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleClearForm = () => {
        setState((prevState) => ({
            ...prevState,
            selectedCompetitorChainCode: '',
            selectedCompetitorStoreCode: '',
            selectedStoreCode: '',
        }));
    };

    const handleSubmitForm = () => {
        getChangeRequests(1);
    };

    const nbpbkbnTable = getNbpbkbnTable(t);

    const handleCloseNbpbkbnModal = () => {
        setState((prevState) => ({
            ...prevState,
            isShowNbpbkbnModal: false,
        }));
    };

    const getTabs = () => {
        if (confirmRequestId) {
            return [
                {
                    title: t('price_request.nearby_stores_tab'),
                    event: 'mailConfirmTab',
                    content: renderTable(),
                    count: nearbyCount,
                },
            ];
        }
        if (isCompetitor && !isRemandPage) {
            // 競合対抗かつ差戻でなければ近隣店舗連携データを表示
            return [
                {
                    title: isConfirmPage ? t('price_request.price_registration_confirm_tab') : t('price_request.price_registration_tab'),
                    event: 'confirmTab',
                    content: renderTable(),
                },
                {
                    title: t('price_request.nearby_stores_tab'),
                    event: 'mailConfirmTab',
                    content: renderTable(),
                    count: nearbyCount,
                },
            ];
        }
        return [
            {
                event: 'confirmTab',
                content: renderTable(),
            },
        ];
    };

    return (
        <>
            {isRequestingPage && isShowForm && (
                <Card handleSubmit={handleSubmitForm} handleClear={handleClearForm}>
                    <Label type="column" text={t('price_request.competitor_name.title')} className="col-lg-2 mb-2 mb-lg-4" />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <SelectSearch
                            onChange={(option) => {
                                handleChangeState('selectedCompetitorChainCode', option.value);
                                handleChangeState('selectedCompetitorStoreCode', '');
                            }}
                            options={createCompetitorChainOptions(competitorChains)}
                            value={selectedCompetitorChainCode}
                            placeholder={t('price_request.competitor_name.placeholder')}
                        />
                    </div>
                    <Label type="column" text={t('price_request.competitor_store_name.title')} className="col-lg-2 pl-lg-3 mb-2 mb-lg-4" />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <SelectSearch
                            onChange={(option) => handleChangeState('selectedCompetitorStoreCode', option.value)}
                            options={createCompetitorStoreOptions(competitorStores, selectedCompetitorChainCode)}
                            value={selectedCompetitorStoreCode}
                            disabled={!selectedCompetitorChainCode}
                            placeholder={t('price_request.competitor_store_name.placeholder')}
                        />
                    </div>
                    <Label type="column" text={t('price_request.oke_store_name.title')} className="col-lg-2 mb-2 mb-lg-4 fixed_height" />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <SelectSearch
                            onChange={(option) => handleChangeState('selectedStoreCode', option.value)}
                            options={createStoreOptions(stores)}
                            value={selectedStoreCode}
                            placeholder={t('price_request.oke_store_name.placeholder')}
                        />
                    </div>
                </Card>
            )}

            {isRemandPage && (
                <div className="okc-card">
                    <Card type="modal_card">
                        <div className="row okc-card__row align-items-start">
                            <Label
                                type="column"
                                text={t('confirm_registration_price.remand.search_form.registration_date')}
                                className="col-lg-2 pl-lg-3"
                            />
                            <div className="col-lg-3">
                                <ReactCalender
                                    value={requestedDate}
                                    placeholder=""
                                    onChange={(value) => {
                                        handleChangeState('requestedDate', value);
                                    }}
                                />
                            </div>
                            <div className="col offset-lg-1">
                                <Button className="btn btn--primary" onClick={() => handleSubmitForm()}>
                                    <span className="btn-text">{t('confirm_registration_price.remand.search_form.search_button')}</span>
                                </Button>
                            </div>
                        </div>
                    </Card>
                </div>
            )}

            <div id="pagination" className="d-flex c-slide-top paginate-custom wp-pagination">
                <nav className="okc-pagination okc-pagination--total ml-auto">
                    <p className="okc-pagination__total">全{apiResponse?.totalCount}件</p>
                    <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                </nav>
            </div>
            <div className="ok_tab_table">
                <Tabs
                    type="material"
                    tabs={getTabs()}
                    style={{ position: 'relative', border: 0 }}
                    handleClick={(event) => handleShowForm(event)}
                />
            </div>
            <div className={`okc-delete d-flex justify-content-between ${btn && 'mb-5'}`}>
                <div className="d-flex okc-pagination-bottom">
                    <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                </div>
                {btn && btn()}
            </div>
            <Popup
                isShow={isShowModal}
                size="sm"
                btnList={[
                    {
                        name: 'はい',
                        className: 'btn--primary',
                        onClick: () => handleChangeState('isShowModal', false),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('freshness.price_request.modal.first_content')}</p>
                        <p className="text-center">{t('freshness.price_request.modal.second_content')}</p>
                        <p className="text-center">{t('freshness.price_request.modal.third_content')}</p>
                    </>
                }
            ></Popup>
            <Modal
                size="sm"
                isShow={isShowNbpbkbnModal}
                onClose={handleCloseNbpbkbnModal}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--primary',
                        onClick: () => handleCloseNbpbkbnModal(),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('price_registration.nbpbkbn_modal.message')}</p>
                        <ViewTable heads={nbpbkbnTable.heads} body={nbpbkbnTable.body} dataTable={nbpbkbnData} />
                    </>
                }
            />
        </>
    );
};

export default ChangeRequestBase;
